import { render } from "./ResidentDetails.vue?vue&type=template&id=2603f737&scoped=true"
import script from "./ResidentDetails.vue?vue&type=script&lang=js"
export * from "./ResidentDetails.vue?vue&type=script&lang=js"

import "./ResidentDetails.vue?vue&type=style&index=0&id=2603f737&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2603f737"]])

export default __exports__